import clsx from 'clsx';
import React from 'react';

export type MosaicListProps = Readonly<{
  ariaLabel?: string;
  ariaLabelledBy?: string;
  as?: 'ol' | 'ul';
  columns?: 2 | 3 | 4;
  items?: React.ReactElement[];
}>;

function MosaicList({
  ariaLabel,
  ariaLabelledBy,
  as: Component = 'ul',
  columns = 4,
  items = [],
}: MosaicListProps): JSX.Element {
  return (
    <Component
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledBy}
      className={clsx('mosaic-list', `mosaic-list--col-${columns}`)}
      role="list"
    >
      {items.map((item, i) => (
        <li key={item?.key ?? i} className="mosaic-list__item">
          {item}
        </li>
      ))}
    </Component>
  );
}

export default MosaicList;
